import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { RemoteShellWebComponentSchema } from '../types';

export class RemoteShellBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<RemoteShellWebComponentSchema> {
    throw new Error('Not implemented');
  }
  async getAuthenticationSettings(companyId) {
    throw new Error('Not implemented');
  }
}
